<template>
  <span class="device-status"><font-awesome-icon class="device-status-icon" icon="circle" size="1x" :style="{ color: color }" /> {{stateText}}</span>
</template>
<script>
export default {
  name: 'WatchState',
  props: ['location'],
  data () {
    return {
      color: '',
      stateText: ''
    }
  },
  mounted () {
    this.setStatus()
  },
  methods: {
    setStatus () {
      if (!this.location || !this.location.lat) {
        this.color = 'rgba(20,20,20,0.2)'
        this.stateText = 'Не отслеживается'
        return
      }
      const date = new Date(this.location.lat.timestamp + 'Z')
      const now = Date.now()
      const diff = now - date
      if (diff > 60 * 60000) { // Больше часа
        this.color = '#e95b5a'
        this.stateText = `${Math.round(diff / (60 * 60000))}ч. назад`
        return
      }
      if (now - date > 60000) { // Больше минуты
        this.color = '#E8CF72'
        this.stateText = `${Math.round(diff / 60000)}м. назад`
        return
      }
      this.color = '#43E872'
      this.stateText = 'Недавно'
    }
  },
  watch: {
    location: {
      handler () {
        this.setStatus()
      },
      deep: true
    }
  }
}
</script>
